import {Directive, EventEmitter, HostListener, Output} from '@angular/core';

@Directive({
	selector: '[onBlur]'
})

/**
 * Creates a (onBlur) HTML directive that can be used when someone exits
 * an INPUT field.
 *
 * NOTE: This will work only on the Typeaheads.
 */
export class OnBlurDirective {

	constructor() { }

	@Output('onBlur') onBlurEvent: EventEmitter<any> = new EventEmitter();

	@HostListener('focusout', ['$event.target'])

	/**
	 * Trigger the onBlur's function when the item with
	 * (onBlur) in its attributes is left by the user.
	 *
	 * @param {any} target  The item losing focus.
	 */
	onFocusout(target:any) {

		this.onBlurEvent.emit()

	}

}



// WEBPACK FOOTER //
// ./src/app/directives/on-blur.directive.ts